import React, { useEffect, useState } from 'react';
import SmartAppBannerConfigurationService from '../services/SmartAppBannerConfigurationService';
import SmartBanner from 'react-smartbanner';
import Translation from '../../Shared/components/Translation';
import { renderToString } from 'react-dom/server';
import '../smart-app-banner.scss';
const SmartAppBanner = () => {
    const [configuration, setConfiguration] = useState(null);
    useEffect(() => {
        if (!configuration) {
            SmartAppBannerConfigurationService.get().then(setConfiguration);
        }
    });
    if (!(configuration === null || configuration === void 0 ? void 0 : configuration.enabled) || !(configuration === null || configuration === void 0 ? void 0 : configuration.title))
        return null;
    return (React.createElement(SmartBanner, { title: configuration.title, button: renderToString(React.createElement(Translation, { item: 'tx_zigsitepackage.smartAppBanner.view', asString: true })), storeText: {
            ios: renderToString(React.createElement(Translation, { item: 'tx_zigsitepackage.smartAppBanner.store.ios' })),
            android: renderToString(React.createElement(Translation, { item: 'tx_zigsitepackage.smartAppBanner.store.android' })),
        }, price: {
            ios: renderToString(React.createElement(Translation, { item: 'tx_zigsitepackage.smartAppBanner.price', asString: true })),
            android: renderToString(React.createElement(Translation, { item: 'tx_zigsitepackage.smartAppBanner.price', asString: true })),
        }, position: "bottom" }));
};
export default SmartAppBanner;
